import { createSelector } from "@reduxjs/toolkit";

import {
  dispatchParamSelector,
  getMultilingualNodeConfigSelector,
  getNodeTypeIdSelector,
} from "@skilitics/nautilus-core-designer-data";

import {
  getManifestSelector,
  languageCodesSelector,
  validateNodeConfigSelector,
  validateNodeRoleSelector,
} from "../contextualSelectors/index.ts";
import { getMultilingualOptInEnabledSelector } from "../multilingualPropertiesSelectors/index.ts";
import { mutateCreate } from "../mutate.ts";

export const mutateNodeDesignsSelector = createSelector(
  [
    getMultilingualNodeConfigSelector,
    getManifestSelector,
    validateNodeConfigSelector,
    getNodeTypeIdSelector,
    languageCodesSelector,
    validateNodeRoleSelector,
    getMultilingualOptInEnabledSelector,
    dispatchParamSelector,
  ],
  (
    getConfigMultilingual,
    getManifest,
    validateConfig,
    getNodeTypeId,
    languageCodes,
    validateNodeRole,
    getMultilingualOptInEnabled,
    dispatch,
  ) =>
    mutateCreate({
      dispatch,
      getConfigMultilingual,
      getManifest,
      validateConfig,
      getNodeTypeId,
      languageCodes,
      validateNodeRole,
      getMultilingualOptInEnabled,
    }),
);
